"use strict";
/**
 * @enum Actions
 * @description Defines the actions used in integrations gateway.
 */
var _a, _b;
exports.__esModule = true;
exports.fileTypeToAction = exports.actionToFileType = exports.Actions = void 0;
// !!! IMPORTANT !!!
// If you change this file you will need to generate migrations in integrations gateway
var FileTypes_1 = require("./FileTypes");
var CustodianId_1 = require("../common/CustodianId");
var Actions;
(function (Actions) {
    Actions["accountCreation"] = "accountCreation";
    Actions["accountUpdate"] = "accountUpdate";
    Actions["investmentUpdate"] = "investmentUpdate";
    Actions["initiateDeposit"] = "initiateDeposit";
    Actions["initiateTrade"] = "initiateTrade";
    Actions["initiateDisbursement"] = "initiateDisbursement";
    Actions["initiateCheckDisbursement"] = "initiateCheckDisbursement";
    Actions["initiateCashTransfer"] = "initiateCashTransfer";
    Actions["initiateExternalAccountCashTransfer"] = "initiateExternalAccountCashTransfer";
    Actions["initiateStopCheck"] = "initiateStopCheck";
    Actions["accountCreationStatus"] = "accountCreationStatus";
    Actions["investmentUpdateStatus"] = "investmentUpdateStatus";
    Actions["cashDisbursementStatus"] = "cashDisbursementStatus";
    Actions["cashTransferStatus"] = "cashTransferStatus";
    Actions["checkRegisterStatus"] = "checkRegisterStatus";
    Actions["confirmationStatus"] = "confirmationStatus";
    Actions["depositStatus"] = "depositStatus";
    Actions["cashInActivity"] = "cashInActivity";
    Actions["tradeStatus"] = "tradeStatus";
    Actions["retrieveFundRules"] = "retrieveFundRules";
    Actions["retrieveDistributionDeclarations"] = "retrieveDistributionDeclarations";
    Actions["retrievePricesAndRates"] = "retrievePricesAndRates";
    Actions["custodianReconDividendActivity"] = "custodianReconDividendActivity";
    Actions["custodianReconFundActivity"] = "custodianReconFundActivity";
    Actions["custodianReconPosition"] = "custodianReconPosition";
    Actions["custodianReconBalance"] = "custodianReconBalance";
    Actions["retrieveDivDeclarations"] = "retrieveDivDeclarations";
    Actions["retrievePrices"] = "retrievePrices";
    Actions["retrieveDivAccrualRates"] = "retrieveDivAccrualRates";
    Actions["retrieveFundInformation"] = "retrieveFundInformation";
    Actions["selfDirectedAccountCashTransferStatus"] = "selfDirectedAccountCashTransferStatus";
    Actions["selfDirectedAccountValue"] = "selfDirectedAccountValue";
    Actions["selfDirectedAccountPosition"] = "selfDirectedAccountPosition";
    Actions["selfDirectedAccountMapping"] = "selfDirectedAccountMapping";
    Actions["depositStatusL2"] = "depositStatusL2";
    Actions["depositStatusL3"] = "depositStatusL3";
    Actions["disbursementStatusL2"] = "disbursementStatusL2";
    Actions["disbursementStatusL3"] = "disbursementStatusL3";
})(Actions = exports.Actions || (exports.Actions = {}));
var actionToFile = (_a = {},
    _a[Actions.accountCreation] = FileTypes_1.FileTypes.accountMaster,
    _a[Actions.accountUpdate] = FileTypes_1.FileTypes.accountMaster,
    _a[Actions.initiateTrade] = FileTypes_1.FileTypes.trade,
    _a[Actions.initiateDeposit] = FileTypes_1.FileTypes.ach,
    _a[Actions.initiateCashTransfer] = FileTypes_1.FileTypes.cashTransfer,
    _a[Actions.initiateExternalAccountCashTransfer] = FileTypes_1.FileTypes.selfDirectedAccountCashTransferRequest,
    _a[Actions.initiateDisbursement] = FileTypes_1.FileTypes.cashDisbursement,
    _a[Actions.investmentUpdate] = FileTypes_1.FileTypes.investment,
    _a[Actions.depositStatus] = FileTypes_1.FileTypes.ach,
    _a[Actions.cashInActivity] = FileTypes_1.FileTypes.cashIn,
    _a[Actions.retrieveFundRules] = FileTypes_1.FileTypes.fundRules,
    _a[Actions.retrieveDistributionDeclarations] = FileTypes_1.FileTypes.distributionDeclarations,
    _a[Actions.retrievePricesAndRates] = FileTypes_1.FileTypes.priceAndRate,
    _a[Actions.custodianReconDividendActivity] = FileTypes_1.FileTypes.custodianReconDividendActivity,
    _a[Actions.custodianReconFundActivity] = FileTypes_1.FileTypes.transactionActivity,
    _a[Actions.custodianReconPosition] = FileTypes_1.FileTypes.custodianReconPosition,
    _a[Actions.custodianReconBalance] = FileTypes_1.FileTypes.custodianReconBalance,
    _a[Actions.retrieveDivDeclarations] = FileTypes_1.FileTypes.divDeclaration,
    _a[Actions.retrievePrices] = FileTypes_1.FileTypes.price,
    _a[Actions.retrieveDivAccrualRates] = FileTypes_1.FileTypes.rate,
    _a[Actions.retrieveFundInformation] = FileTypes_1.FileTypes.fundInformation,
    _a[Actions.cashDisbursementStatus] = FileTypes_1.FileTypes.cashDisbursement,
    _a[Actions.checkRegisterStatus] = FileTypes_1.FileTypes.checkRegister,
    _a[Actions.cashTransferStatus] = FileTypes_1.FileTypes.cashTransfer,
    _a[Actions.selfDirectedAccountCashTransferStatus] = FileTypes_1.FileTypes.selfDirectedAccountCashTransferStatus,
    _a[Actions.selfDirectedAccountValue] = FileTypes_1.FileTypes.selfDirectedAccountValue,
    _a[Actions.selfDirectedAccountMapping] = FileTypes_1.FileTypes.selfDirectedAccountMapping,
    _a[Actions.selfDirectedAccountPosition] = FileTypes_1.FileTypes.selfDirectedAccountPosition,
    _a);
var actionToFileBNY = (_b = {},
    _b[Actions.cashInActivity] = FileTypes_1.FileTypes.bnyCashActivityFileBAI2,
    _b[Actions.custodianReconBalance] = FileTypes_1.FileTypes.bnyCashBalanceFileBAI2,
    _b[Actions.checkRegisterStatus] = FileTypes_1.FileTypes.bnyCheckRegister,
    _b[Actions.depositStatus] = FileTypes_1.FileTypes.ach,
    _b[Actions.initiateDeposit] = FileTypes_1.FileTypes.bnyDeposit,
    _b[Actions.initiateDisbursement] = FileTypes_1.FileTypes.bnyCashDisbursement,
    _b[Actions.initiateCheckDisbursement] = FileTypes_1.FileTypes.bnyCheckDisbursement,
    _b[Actions.depositStatusL2] = FileTypes_1.FileTypes.bnyAchWireStatusL2,
    _b[Actions.depositStatusL3] = FileTypes_1.FileTypes.bnyAchWireStatusL3,
    _b[Actions.disbursementStatusL2] = FileTypes_1.FileTypes.bnyAchWireStatusL2,
    _b[Actions.disbursementStatusL3] = FileTypes_1.FileTypes.bnyAchWireStatusL3,
    _b[Actions.initiateStopCheck] = FileTypes_1.FileTypes.bnyStopCheck,
    _b);
var actionToFileType = function (action, sourceId) {
    if (sourceId === CustodianId_1.CustodianId.bnyTreasury) {
        if (actionToFileBNY[action]) {
            return actionToFileBNY[action];
        }
        else {
            throw new Error("Action ".concat(action, " is not supported for BNY Treasury"));
        }
    }
    else {
        if (actionToFile[action]) {
            return actionToFile[action];
        }
        else {
            throw new Error("Action ".concat(action, " is not supported for ").concat(sourceId));
        }
    }
};
exports.actionToFileType = actionToFileType;
var fileTypeToAction = function (fileType) {
    var actionToFilekeys = Object.keys(actionToFile);
    return actionToFilekeys.find(function (key) {
        return !!Actions[key] ? actionToFile[Actions[key]] === fileType : false;
    });
};
exports.fileTypeToAction = fileTypeToAction;
